import React from "react";

const MicrosoftExcelIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6_10415)">
      <path
        d="M2.33362 4.37606V1.75106C2.33362 1.59635 2.39508 1.44798 2.50447 1.33858C2.61387 1.22918 2.76224 1.16772 2.91695 1.16772H11.0836C11.2383 1.16772 11.3867 1.22918 11.4961 1.33858C11.6055 1.44798 11.667 1.59635 11.667 1.75106V12.2511C11.667 12.4058 11.6055 12.5541 11.4961 12.6635C11.3867 12.7729 11.2383 12.8344 11.0836 12.8344H2.91695C2.76224 12.8344 2.61387 12.7729 2.50447 12.6635C2.39508 12.5541 2.33362 12.4058 2.33362 12.2511V9.62606"
        stroke="#03B0F7"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.04175 4.37622H9.91675M8.16675 6.70955H9.91675M8.16675 9.04289H9.91675"
        stroke="#03B0F7"
        strokeWidth="1.16667"
        strokeLinecap="round"
      />
      <path
        d="M2.91675 6.12622L4.66675 7.87622M4.66675 6.12622L2.91675 7.87622M1.16675 4.37622H6.41675V9.62622H1.16675V4.37622Z"
        stroke="#03B0F7"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6_10415">
        <rect
          width="14"
          height="14"
          fill="white"
          transform="translate(0 0.000976562)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default MicrosoftExcelIcon;
